import { render, staticRenderFns } from "./RegexEditor.vue?vue&type=template&id=9a1ca1a8&scoped=true&"
import script from "./RegexEditor.vue?vue&type=script&lang=js&"
export * from "./RegexEditor.vue?vue&type=script&lang=js&"
import style0 from "./RegexEditor.vue?vue&type=style&index=0&id=9a1ca1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1ca1a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
